export default __webpack_public_path__ + "static/bachata-home-adf71c98186110031e4b5ad640bc2648.jpg";